export const getSaleCountLabel = (saleCount: number): string => {
  let countLabel = "";

  if (saleCount >= 1_000_000) {
    countLabel = `${(Math.floor(saleCount / 100_000) / 10).toFixed(1)}M+`; // 保留1位小数
  } else if (saleCount >= 1000) {
    countLabel = `${(Math.floor(saleCount / 100) / 10).toFixed(1)}K+`; // 保留1位小数
  } else if (saleCount >= 100) {
    countLabel = `${Math.floor(saleCount / 100) * 100}+`; // 百位数显示
  } else {
    countLabel = `${saleCount}`; // 小于100直接显示
  }

  return countLabel;
};
